import React, { useState, useEffect } from 'react';
import { TotalData, TradingTabKeyNames } from '../../index.type';
import { extractNumber, times100 } from '@/lib/utils';
interface TradingFrequencyAnalysisProps {
  selectedMetrics: {
    tradingFrequency?: boolean;
    [key: string]: boolean | undefined;
  };
  totalData: Pick<TotalData, TradingTabKeyNames>;
}

interface TradingData {
  title: string;
  value: string;
  unit: string;
}

const TradingFrequencyAnalysis: React.FC<TradingFrequencyAnalysisProps> = ({
  selectedMetrics,
  totalData
}) => {
  const [currentSelectedMetrics, setCurrentSelectedMetrics] = useState<{
    tradingFrequency?: boolean;
    [key: string]: boolean | undefined;
  }>({});

  // 模拟接口返回的数据

  const [tradingData, setTradingData] = useState<TradingData[]>([]);

  useEffect(() => {
    setCurrentSelectedMetrics(selectedMetrics);
  }, [selectedMetrics]);

  useEffect(() => {
    const data = [
      {
        title: '年化周转率',
        value: times100(totalData.annual_turnover_rate).toString(),
        unit: '%'
      },
      {
        title: '月均交易次数',
        value: extractNumber(totalData.monthly_avg_trades),
        unit: '次'
      },
      {
        title: '平均持仓周期',
        value: extractNumber(totalData.avg_holding_period),
        unit: '天'
      }
    ];

    setTradingData(data);
  }, [totalData]);

  // 模拟数据变化
  useEffect(() => {
    const interval = setInterval(() => {}, 2000); // 每2秒更新一次数据

    return () => clearInterval(interval);
  }, []);

  const handleCheckboxChange = (checked: boolean) => {
    setCurrentSelectedMetrics(prev => ({
      ...prev,
      tradingFrequency: checked
    }));
  };

  return (
    <div className="my-4 rounded-lg border border-[#F0F0F0] p-3">
      {/* 标题和复选框 */}
      <div className="mb-4 flex items-center gap-2">
        <input
          type="checkbox"
          checked={currentSelectedMetrics.tradingFrequency || false}
          onChange={e => handleCheckboxChange(e.target.checked)}
          className="h-4 w-4"
        />
        <span className="text-base font-semibold text-[#1F1F1F]">
          交易频率分析
        </span>
      </div>

      {/* 交易频率分析指标卡片 */}
      <div className="grid gap-2">
        {tradingData.map(item => (
          <div key={item.title} className="bg-white">
            <div className="flex items-center justify-between">
              <span className="text-xs text-[#1F1F1F]">{item.title}</span>
              <span>
                <span className="text-sm font-semibold text-[#1F1F1F]">
                  {item.value}
                </span>
                <span className="text-xs text-[#1F1F1F]">{item.unit}</span>
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TradingFrequencyAnalysis;
